"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Completedservicesgallery() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const projects = [{
    number: "—01",
    title: "Irrigation Systems",
    image: "https://aaeagleplumbing.com/wp-content/uploads/2026/08/Irrigation_system_work.jpg",
    alt: "Irrigation system installation work"
  }, {
    number: "—02",
    title: "System Maintenance",
    image: "https://aaeagleplumbing.com/wp-content/uploads/2026/08/Irrigation_system_work-2.jpg",
    alt: "Irrigation system maintenance work"
  }, {
    number: "—03",
    title: "Panel Upgrades",
    image: "https://aaeagleplumbing.com/wp-content/uploads/2026/08/domestic-duplex-system-control-panel-upgrade.jpg",
    alt: "Domestic duplex system control panel upgrade"
  }];
  return <section data-section-id="3356" id="completedservicesgallery" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        {/* Header Section */}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-12 md:mb-16 transition-all duration-1000 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-7 flex gap-6 md:gap-10">
            <div className="hidden md:flex items-start pt-2">
              <span className="font-mono text-xs tracking-[0.25em] text-muted-foreground uppercase whitespace-nowrap" style={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)"
            }}>
                02 — Services
              </span>
            </div>
            <div className="flex-1">
              <span className="md:hidden font-mono text-xs tracking-[0.25em] text-muted-foreground uppercase mb-4 block">
                02 — Services
              </span>
              <h2 className="font-serif italic font-light text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-foreground">
                Expert
                <br />
                solutions
              </h2>
            </div>
          </div>

          <div className="lg:col-span-5 lg:pt-6 flex flex-col justify-between gap-8">
            <p className="font-sans text-base md:text-lg leading-relaxed text-muted-foreground max-w-md">
              AA Eagle Plumbing delivers fast, reliable mechanical services for commercial and residential systems. Explore our recent work on irrigation systems and pool pump installations.
            </p>
            <Link to="/ServicesPage" className="group inline-flex items-center gap-3 font-mono text-xs tracking-[0.25em] uppercase text-foreground hover:text-primary transition-colors duration-500 w-fit">
              <span className="border-b border-foreground/30 group-hover:border-primary pb-1 transition-colors duration-500">
                View all services
              </span>
              <ArrowUpRight className="size-4 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.25} />
            </Link>
          </div>
        </div>

        {/* Gallery Grid */}
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {projects.map((project, index) => <ProjectCard key={index} project={project} className={`transition-all duration-1000 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${index * 150}ms`
        }} aspectClass="aspect-[4/3]" />)}
        </div>
      </div>
    </section>;
}
type Project = {
  number: string;
  title: string;
  image: string;
  alt: string;
};
function ProjectCard({
  project,
  className = "",
  style,
  aspectClass
}: {
  project: Project;
  className?: string;
  style?: React.CSSProperties;
  aspectClass: string;
}) {
  return <div className={className} style={style}>
      <div className="group block relative w-full">
        {/* Image Container */}
        <div className={`relative overflow-hidden ${aspectClass} bg-muted`}>
          <img src={project.image} alt={project.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105" />
        </div>

        {/* Footer Info (Always visible, clean design) */}
        <div className="mt-5 flex items-baseline justify-between gap-4">
          <h3 className="font-serif italic font-light text-2xl text-foreground leading-tight">
            {project.title}
          </h3>
          <span className="font-mono text-[10px] tracking-[0.2em] text-muted-foreground whitespace-nowrap">
            {project.number}
          </span>
        </div>
      </div>
    </div>;
}